import { render } from "./vipMemberType.vue?vue&type=template&id=cad088d2"
import script from "./vipMemberType.vue?vue&type=script&lang=js"
export * from "./vipMemberType.vue?vue&type=script&lang=js"

import "./vipMemberType.vue?vue&type=style&index=0&id=cad088d2&lang=scss&scope=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__